export const DASHBOARD_ROUTE = 'DASHBOARD_ROUTE';
export const LOGIN_ROUTE = 'LOGIN_ROUTE';
export const SIGNUP_ROUTE = 'SIGNUP_ROUTE';
export const FORGOT_PASSWORD_ROUTE = 'FORGOT_PASSWORD_ROUTE';
export const RESET_PASSWORD_ROUTE = 'RESET_PASSWORD_ROUTE';
export const VERIFY_EMAIL_ROUTE = 'VERIFY_EMAIL_ROUTE';
export const EMAIL_VERIFICATION_WALL_ROUTE = 'EMAIL_VERIFICATION_WALL_ROUTE';
export const ORGANIZATIONS_ROUTE = 'ORGANIZATIONS_ROUTE';
export const NEW_ORGANIZATION_ROUTE = 'NEW_ORGANIZATION_ROUTE';
export const EDIT_ORGANIZATION_ROUTE = 'EDIT_ORGANIZATION_ROUTE';

export const ORGANIZATION_DETAILS_ROUTE = 'ORGANIZATION_DETAILS_ROUTE';
export const ORGANIZATION_SCREENS_ROUTE = 'ORGANIZATION_SCREENS_ROUTE';
export const NEW_SCREEN_ROUTE = 'NEW_SCREEN_ROUTE';
export const DISPLAY_ROUTE = 'DISPLAY_ROUTE';
export const ORGANIZATION_USERS_ROUTE = 'ORGANIZATION_USERS_ROUTE';
export const ORGANIZATION_ACTIVITY_ROUTE = 'ORGANIZATION_ACTIVITY_ROUTE';
export const ORGANIZATION_SETTINGS_ROUTE = 'ORGANIZATION_SETTINGS_ROUTE';

export const TICKETS_ROUTE = 'TICKETS_ROUTE';
export const CHAT_ROUTE = 'CHAT_ROUTE';

export const ERROR_ROUTE = 'ERROR_ROUTE';
export const NOT_FOUND_404_ROUTE = 'NOT_FOUND_404_ROUTE';
